document.addEventListener('DOMContentLoaded', function() {
  const collectionTitles = document.querySelectorAll('.featured-collections__title');
  const collections = document.querySelectorAll('.featured-collections__collection');

  collectionTitles.forEach(title => {
    title.addEventListener('click', function() {
      // Remove active class from all titles and collections
      collectionTitles.forEach(t => t.classList.remove('active'));
      collections.forEach(c => c.classList.remove('active'));

      // Add active class to clicked title
      this.classList.add('active');

      // Show corresponding collection
      const collectionId = this.getAttribute('data-collection-title-id');
      // console.log("collectionId ", collectionId);

      const targetCollection = document.querySelector(`[data-collection-id="${collectionId}"]`);
      // console.log("targetCollection ", targetCollection);
      
      if (targetCollection) {
        document.querySelectorAll(`[data-collection-id]`).forEach(c => c.classList.remove('active'));
        targetCollection.classList.add('active');
      }
    });
  });
});
